module.exports = __webpack_public_path__ + "static/media/i42.351b734e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i42.svg
// module id = 228
// module chunks = 12